// ABOUTME: TabView3 configuration for the openapi keys page.
// ABOUTME: Single tab "all" rendering the datagrid view.
import VpnKeyOutlinedIcon from '@mui/icons-material/VpnKeyOutlined';

export const settingsIntegrationsOpenapiConfig = {
    all: {
        title: "openapi_keys",
        icon: <VpnKeyOutlinedIcon/>,
        isSingleDataGrid: true,
    },
};
